import React from 'react';

const BigEmailIcon = () => <svg width='96' height='96' viewBox='0 0 96 96' fill='none' xmlns='http://www.w3.org/2000/svg'>
  <g clipPath='url(#clip0_6371_34073)'>
    <circle cx='48' cy='48' r='48' fill='#0FD08B' />
    <path d='M30.6904 33.9299L48.0004 49.6666L65.3088 33.9316' stroke='white' strokeWidth='3.33333' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round' />
    <path d='M63.0001 33H33.0001C31.1591 33 29.6667 34.4924 29.6667 36.3333V59.6667C29.6667 61.5076 31.1591 63 33.0001 63H63.0001C64.841 63 66.3334 61.5076 66.3334 59.6667V36.3333C66.3334 34.4924 64.841 33 63.0001 33Z' stroke='white' strokeWidth='3.33333' strokeMiterlimit='10' strokeLinecap='round' strokeLinejoin='round' />
  </g>
  <defs>
    <clipPath id='clip0_6371_34073'>
      <rect width='96' height='96' fill='white' />
    </clipPath>
  </defs>
</svg>


export default BigEmailIcon;
